export const isIterable = (obj) => obj && typeof obj[Symbol.iterator] === "function";